export default __webpack_public_path__ + "static/media/smiling_girl.d19e3880.png";